/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, requestId: NonNullable<unknown> }} Station_Readiness_BlockedInputs */

const vi_station_readiness_blocked = /** @type {(inputs: Station_Readiness_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máy trạm chưa được giám sát từ ${i?.time} — báo quản trị, mã ${i?.requestId}`)
};

/**

* @param {Station_Readiness_BlockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_readiness_blocked = /** @type {((inputs: Station_Readiness_BlockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Readiness_BlockedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_readiness_blocked(inputs)
});